/**
 * Registry mapping a task context to the detail component that renders it.
 *
 * The generic task module stays domain-agnostic: it never imports a concrete
 * detail view. Each domain registers its renderer from its own registration
 * module (loaded eagerly at app bootstrap), so adding a domain never requires
 * editing this file or the dispatcher — you just register another entry.
 */

const DEFAULT_KEY = Symbol("default");

const registry = new Map();

/** Register the detail component used for tasks with the given context. */
export const registerTaskDetail = (context, component) => {
    registry.set(context, component);
};

/** Register the fallback detail component for contexts without a specific entry. */
export const registerDefaultTaskDetail = (component) => {
    registry.set(DEFAULT_KEY, component);
};

/** Resolve the detail component for a task context (falls back to the default). */
export const resolveTaskDetail = (context) => {
    return registry.get(context) || registry.get(DEFAULT_KEY) || null;
};
